import Axios from '@/request/request';

/* 抽奖历史 */
export const queryLuckyDrawHistory = (params: { skip: string; limit: number; gameId: string }) => {
  return Axios.get(`/activity/lottery/history`, { params });
};
